// Panel dédié Gemini CLI — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const GeminiCliPanel: Component = () => <CliPanel cli="gemini" />;

registerPanel("cli-gemini", GeminiCliPanel);
export default GeminiCliPanel;
